/**
 * File: /Users/tomasmuniesa/Documents/develop/nousmedis/nm-apps/2_syncwall/Develop/syncwall-frontend/src/app/modules/menus/components/user-options-side-menu/user-options-side-menu.component.ts
 * Project: /Users/tomasmuniesa/Documents/develop/nousmedis/nm-apps/2_syncwall/Develop/syncwall-frontend
 * Created Date: Tuesday, April 30th 2024, 6:20:53 pm
 * Author: Tomás
 * -----
 * Last Modified:  Thursday, 24th October 2024 9:23:09 am
 * Modified By: Tomás (tomas@cege.es>)
 * -----
 * Copyright (c) 2024 Nousmedis, CeGe
 * ------------------------------------
 * Javascript will save your soul!
 */



import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { User } from "@nousmedis/guard-types/frontend";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { MenuItem } from "primeng/api";
import { Menu } from "primeng/menu";
import { UserModel } from "app/modules/user/models/user.model";
import { AuthModel } from "@nousmedis/nm-guard-auth";
import { UserService } from "app/modules/user/services/user.service";
import { ApiService } from "app/modules/api/services/api.service";
import { CookieService } from "ngx-cookie-service";

@Component({
  selector: "user-options-side-menu",
  templateUrl: "./user-options-side-menu.component.html",
  styleUrls: ["./user-options-side-menu.component.scss"],
})
export class UserOptionsSideMenuComponent implements OnInit {
  @Input() user: User;
  @ViewChild('menu_top', { static: false }) menu_top: Menu;
  userModel: UserModel;
  roleCode: string;
  currentOrg: string;
  orgs: any[];
  menuitems: MenuItem[] = [];
  itemsLoaded: boolean = false;

  constructor (
    private translate: TranslateService,
    private auth: AuthModel,
    private router: Router,
    private userService: UserService,
    api: ApiService,
    cookie: CookieService,
  ) {
    this.userModel = new UserModel(api, cookie);
    this.roleCode = this.auth.getRoleCode();
  }

  ngOnInit(): void {
    this.orgSubscription();
    this.onChangeUser();
    this.user = this.auth.getCurrentUser();
    if (this.user) {
      this.setUserData();
    }


  }

  private setUserData() {
    let userOrg: any = this.auth.getCurrentUserOrg(this.user.id);
    let cookieOrgs = this.auth.getOrgs();
    this.orgs = cookieOrgs;
    if (this.user && userOrg) {
      this.currentOrg = userOrg.org.name;
    }

    if (this.orgs && this.orgs) {
      this.setMenuItems();
    }
  }

  private onChangeUser() {
    this.userService.user$.subscribe((user) => {
      this.user = user;
      this.setUserData();
    }
    );
  }
  private orgSubscription() {
    this.userService.orgsOfUser$.subscribe((orgs) => {
      this.orgs = orgs;
      if (this.orgs && this.currentOrg) {
        this.setMenuItems();
      }
    });
    this.userService.currentOrg$.subscribe(async (org) => {
      if (org) {
        this.currentOrg = org.name;
        if (!this.orgs) {

        }
        if (this.orgs && this.currentOrg) {
          this.setMenuItems();
        }
      }
    });
  }

  reloadOrgs() {
    this.setMenuItems();
  }

  setMenuItems() {
    let orgItems: MenuItem[] = [];
    for (let i = 0; i < this.orgs.length; i++) {

      if (this.orgs[i].services && this.orgs[i].services.ccserver && this.orgs[i].services.ccserver.length > 0) {

        orgItems.push({
          label: this.orgs[i].name,
          styleClass: "font-semibold	"
        });
        let swServices = this.orgs[i].services.ccserver;

        for (let x = 0; x < swServices.length; x++) {
          orgItems.push({
            label: swServices[x].name,
            icon: "pi pi-sitemap",
            command: () => {
              this.changeOrg(this.user.id, this.orgs[i].id, swServices[x].id);
            }
          });
        }
        if (i < this.orgs.length - 1) {
          orgItems.push({
            separator: true
          });

        }


      }

    }

    /**
     * Es posible que lo volvamos a añadir?
     * {
        label: this.currentOrg,
        icon: "pi pi-sitemap",
        title: "USER.CHANGE_ORG",
        items: orgItems,
      },
     */
    this.menuitems = [
      {
        label: this.user.name,
        icon: "pi pi-user-edit",
        command: () => {
          this.editMe();
        },
        items: [
          {
            label: "USER.CLOSE_SESSION",
            icon: "pi pi-sign-out",
            command: () => {
              this.logout();
            }
          }]
      }

    ];

    this.translateMenuItems(this.menuitems[0].items);
   // this.translateMenuItems(this.menuitems[1].items);

    // this.menuitems[0].items.push(...orgItems);
    this.itemsLoaded = true;
    //  this.menu_top.model = this.menuitems;
  }

  private translateMenuItems(items: MenuItem[]) {
    for (let i = 0; i < items.length; i++) {
      if (!items[i].label) continue;
      this.translate.get(items[i].label).subscribe((res: string) => {
        items[i].label = res;
      });
      if (items[i].items) {
        this.translateMenuItems(items[i].items);
      }
    }

  }

  logout() {
    this.auth.logOut(this.user);
    this.userService.user$.next(undefined);
    this.router.navigate(["/login"]);
  }

  editMe() {
    //this.userModalForms.editForm(this.auth.getCurrentUser());
  }

  //Este método difiere del de guard, ya que para cambiar de organización es necesario el id de la organización y el id de la aplicación
  //Se recibe un link del servidor de Guard con la url para acceder a la aplicación
  async changeOrg(userId: string, orgId: string, appId: string) {
    // Es necesario envíar el id del usuario, el id de la organización y el id de la aplicación
    this.userModel.changeOrg(userId, orgId, appId).then((appUrl: any) => {
      appUrl = appUrl.url;
    });
  }
}
